import styled from 'styled-components'
import IconButton from 'components/IconButton'

export const StyledButton = styled(IconButton).attrs(() => ({
  fullWidth: true
}))`
  &:hover {
    background-color: ${props => props.hoverButtonColor};
  }
`
